import { el } from '../../core/dom.js';
import { button } from '../../components/button.js';
import { syncNowButton } from '../../components/sync-now.js';
import { errorPanel } from '../../components/error.js';
import { withProduct } from '../../core/route-map.js';
import {
  BLIND_COPY, DEPTH_LABELS, answerable, blindSpots, sourceFreshness, sourceName,
} from './model.js';
import { statusNote } from './status.js';

const SOURCE_NOTE = 'Sources — synced and live. Every answer says how fresh its numbers are.';

/**
 * @param {{ breakdown: object, depthStatus: string, depthError: string, sources: object[], connectorsStatus: string, connectorsError: string, productId: string, canEdit?: boolean, onRefresh: () => void }} opts
 */
export function renderSide(opts) {
  return el('aside', { class: 'kb-aside' }, answers(opts), sources(opts), ...blinds(opts));
}

function answers(opts) {
  if (opts.depthStatus === 'error') {
    return errorPanel({
      title: 'Depth could not be loaded',
      message: opts.depthError || 'Try again.',
      action: button('Retry', { onClick: opts.onRefresh }),
    });
  }
  const keys = answerable(opts.breakdown);
  const body = keys.length
    ? keys.map((key) => el('div', { class: 'kb-answer' },
      el('span', null, DEPTH_LABELS[key]),
      el('span', { class: 'kb-mark' }, '✓')))
    : statusNote('Nothing to answer from yet', 'Connect a source and this list fills in.');
  return el('section', { class: 'kb-glass kb-lift kb-panel kb-rv' },
    el('span', { class: 'kb-kicker' }, 'What Bonnie can answer'),
    el('div', null, body));
}

function sources(opts) {
  if (opts.connectorsStatus === 'error') {
    return errorPanel({
      title: 'Sources could not be loaded',
      message: opts.connectorsError || 'Try again.',
      action: button('Retry', { onClick: opts.onRefresh }),
    });
  }
  const rows = (opts.sources || []).map((source) => el('div', { class: 'kb-source' },
    el('span', null, sourceName(source)),
    el('span', { class: 'kb-fresh' }, el('span', { class: 'kb-dot', 'aria-hidden': 'true' }, '● '), sourceFreshness(source)),
    opts.canEdit && source.mode === 'synced' && source.source_id
      ? syncNowButton(source.source_id, 'btn btn-ghost')
      : null));
  const body = rows.length
    ? el('div', { class: 'kb-sources' }, rows)
    : statusNote('No sources yet', 'Connect one and its freshness shows up here.');
  return el('section', { class: 'kb-glass kb-lift kb-panel kb-rv' },
    el('div', null,
      el('span', { class: 'kb-kicker' }, 'Sources'),
      el('p', { class: 'kb-note' }, SOURCE_NOTE)),
    body);
}

function blinds(opts) {
  if (opts.depthStatus !== 'ready') return [];
  return blindSpots(opts.breakdown).map((key) => el('section', { class: 'kb-blind kb-rv' },
    el('span', { class: 'kb-kicker' }, 'Blind spot'),
    el('h3', null, DEPTH_LABELS[key]),
    el('span', { class: 'kb-sub' }, BLIND_COPY[key]),
    el('a', { class: 'kb-btn', href: withProduct('/app/connectors', opts.productId) }, 'Connect ', el('span', { class: 'arw' }, '→'))));
}
